<template>
  <div class="editor-item">
    <editor-header
      :showSettings="false"
      :hasHelper="contentItem.has_helper"
      :title="$t('builder.dashboard_buttons')"
    />
  </div>
</template>

<script>
export default {
  name: 'dashboardButtons',
  props: ['contentItem'],
  data () {
    return {
      isVisible: true
    }
  }
}
</script>
